<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox1">
            <div class="item">
              <el-form-item label="货源单号:" prop="demandNo">
                <el-input placeholder="" v-model="searchFrom.demandNo"></el-input>
              </el-form-item>
              <el-form-item label="发布状态:" prop="triggerStatus">
                <el-select v-model="searchFrom.triggerStatus" placeholder="请选择">
                  <el-option v-for="val in status" :label="val.name" :value="val.id" :key="val.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="竞价类型:" prop="demandType">
                <el-select v-model="searchFrom.demandType" placeholder="请选择">
                  <el-option v-for="val in options" :label="val.name" :value="val.id" :key="val.id"></el-option>
                </el-select>
              </el-form-item>
            </div>
        </div>
        <div class="searchBtnBox">
              <el-form-item>
                  <el-button type="primary" @click="searchFn" v-if="btnFlg[0]">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
                </el-form-item>
                <!-- <el-form-item>
                  <el-button type="primary" @click="addClick">新增</el-button>
                </el-form-item> -->
            </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" @click="editFn(scope.row)" v-if="scope.row.triggerStatus == 2 && btnFlg[2]" >修改时间</el-button>
              <el-button type="text" size="mini" @click="delFn(scope.row)" v-if="scope.row.triggerStatus == 2 && btnFlg[1]">停止发布</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="货源单号" width="240">
          <template slot-scope="scope">
            <span style="color: #0c46a2;cursor: pointer;" @click="detailFn(scope.row)">{{scope.row.demandNo}}</span>
          </template>
        </el-table-column>
         <!-- <el-table-column label="货源单号" width="230" prop="demandNo">

        </el-table-column> -->
        <el-table-column prop="triggerStatus"  min-width="140" :formatter="statusFormat" label="竞价状态"></el-table-column>
        <el-table-column prop="demandType"  min-width="140" :formatter="emptyFn" label="竞价类型">
          <template slot-scope="scope">
              {{['竞价', '抢单', '指派'][scope.row.demandType-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="productTypeName"  min-width="220" :formatter="emptyFn" label="货物类型" show-overflow-tooltip></el-table-column>
        <el-table-column label="委托量" width="160">
          <template slot-scope="scope">
            <div>
              {{scope.row.productWeight}} 吨 / {{scope.row.productNum}} 件
            </div>
          </template>
        </el-table-column>
          <!-- <el-table-column prop="unitPrice"  min-width="220" :formatter="emptyFn" label="发布价格" show-overflow-tooltip></el-table-column> -->
          <div>
          <el-table-column label="发布价格" width="160">
            <template slot-scope="scope">
              <div>
                </div>
              <div v-if="scope.row.demandType == 1">
                <span v-if="scope.row.pricingMethod==1">{{scope.row.lowPrice}} 元/吨 ~ {{scope.row.highPrice}} 元/吨</span>
                <span v-if="scope.row.pricingMethod==2">{{scope.row.lowPrice}} 元 ~ {{scope.row.highPrice}} 元</span>
              </div>
              <div v-if="scope.row.demandType == 2">
                <span v-if="scope.row.pricingMethod==1">{{scope.row.unitPrice}} 元/吨</span>
                <span v-if="scope.row.pricingMethod==2">{{scope.row.unitPrice}} 元</span>
              </div>
            </template>
          </el-table-column>
          </div>

        <el-table-column label="发货信息" width="450">
          <template slot-scope="scope">
            <div class="box1">
              <span style="color:#0c46a2">(发){{scope.row.deliverCompany}}</span>
              <span>{{scope.row.deliverPerson}}</span>
            </div>
            <div class="box1">
              <span>{{scope.row.deliverPhone}}</span>
              <span style="margin-left:10px">{{scope.row.deliverAddress}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="收货信息" width="450">
          <template slot-scope="scope">
            <div class="box1">
              <span style="color:#F56C6C">(收){{scope.row.receivingCompany}}</span>
              <span>{{scope.row.receivingPerson}}</span>
            </div>
            <div class="box1">
              <span>{{scope.row.receivingPhone}}</span>
              <span style="margin-left:10px">{{scope.row.receivingAddress}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="triggerEndDate"  min-width="160" :formatter="dateFormat" label="循环结束日期"></el-table-column>
        <el-table-column prop="triggerStartDate"  min-width="160" :formatter="statusFormat1" label="发布时间点(时)"></el-table-column>
        <el-table-column prop="triggerDuration"  min-width="120" :formatter="emptyFn" label="有效时长(时)" show-overflow-tooltip></el-table-column>
        <el-table-column prop="triggerStopTime"  min-width="170" :formatter="dateTimeFormat" label="实际结束时间"></el-table-column>
        <el-table-column prop="createUserName"  min-width="130" :formatter="emptyFn" label="创建人" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime"  min-width="170" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
     <el-dialog :title="title"  :visible.sync="SQMark" width="450px" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="SQFrom" ref="SQFrom" :rules="rules" class="demo-form-inline jiaoyan" label-width="145px" size="mini">
        <div class="inpBox1">
            <div style="margin: 28px 0;">
                <!-- <el-form-item label="发布时间点:" prop="triggerStartDate">
                  <el-input v-model="SQFrom.triggerStartDate" placeholder="" maxlength="20"></el-input>
                </el-form-item> -->
                <el-form-item label="发布时间点(时):" prop="triggerStartDate">
                <!-- <el-time-picker
                  v-model="SQFrom.triggerStartDate"
                  format="HH"
                  value-format="HH"
                  placeholder="选择时间"
                ></el-time-picker> -->
                  <el-select v-model="SQFrom.triggerStartDate" placeholder="请选择">
                  <el-option v-for="val in status1" :label="val.name" :value="val.name" :key="val.id"></el-option>
                </el-select>
                </el-form-item>
                <el-form-item label="有效时长:" prop="triggerDuration"  class="jiage">
                  <el-input v-model="SQFrom.triggerDuration"  @blur="effectiveTime()" placeholder="" maxlength="20"></el-input><span class="danwei">小时</span>
                </el-form-item>
                <!-- <el-form-item label="循环结束日期:" prop="triggerEndDate">
                  <el-date-picker
                    v-model="SQFrom.triggerEndDate"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item> -->
                 <el-form-item label="循环结束日期:" prop="triggerEndDate" class="inpBox2">
                <el-date-picker
                  v-model="SQFrom.triggerEndDate"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                ></el-date-picker>
            </el-form-item>
             </div>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SQMark = false">取消</el-button>
        <el-button type="primary" @click="SQsave()" v-show="addBtnShow">确定</el-button>
        <el-button type="primary" @click="editSave()" v-show="editBtnShow">修改</el-button>
      </span>
   </el-dialog>
     <el-dialog :title="title"
    @close="closeDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="resetPasswordMark"
    width="500px"
    center>
      <div style="width:30%;margin:10px auto">
        <span>是否停止发布?</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetPasswordMark = false">取 消</el-button>
        <el-button type="primary" @click="passWordSave">确 定</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import {
  sModuleAdd // 添加
} from '@/api/newCrm'
import { cyclicPublishDemandList, stopPublish, updateTriggerTimeInfo } from '@/api/soc-stock'
export default {
  data () {
    return {
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      status1: [
        { name: '00:00', id: 1 },
        { name: '01:00', id: 2 },
        { name: '02:00', id: 3 },
        { name: '03:00', id: 4 },
        { name: '04:00', id: 5 },
        { name: '05:00', id: 6 },
        { name: '06:00', id: 7 },
        { name: '07:00', id: 8 },
        { name: '08:00', id: 9 },
        { name: '09:00', id: 10 },
        { name: '10:00', id: 11 },
        { name: '11:00', id: 12 },
        { name: '12:00', id: 13 },
        { name: '13:00', id: 14 },
        { name: '14:00', id: 15 },
        { name: '15:00', id: 16 },
        { name: '16:00', id: 17 },
        { name: '17:00', id: 18 },
        { name: '18:00', id: 19 },
        { name: '19:00', id: 20 },
        { name: '20:00', id: 21 },
        { name: '21:00', id: 22 },
        { name: '22:00', id: 23 },
        { name: '23:00', id: 24 }
      ],
      ids: '',
      resetPasswordMark: false,
      status: [
        { name: '进行中', id: 2 },
        { name: '已结束', id: 3 }
      ],
      options: [
        { name: '竞价', id: 1 },
        { name: '抢单', id: 2 },
        { name: '指派', id: 3 }
      ],
      title: '',
      addBtnShow: false,
      editBtnShow: false,
      SQFrom: {
      },
      SQMark: false,
      rules: {
        triggerStartDate: [
          { required: true, message: '请输入发布时间点', trigger: 'blur' }
        ],
        triggerDuration: [
          { required: true, message: '请输入有效时长', trigger: 'blur' }
        ],
        triggerEndDate: [
          { required: true, message: '请选择循环结束日期', trigger: 'blur' }
        ]
      },
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: false,
      btnFlg: [],
      btnIdArr: ['00H0030100', '00H0030200', '00H0030300']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/issuance')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    // 状态格式化
    statusFormat1 (row, column, cellValue) {
      console.log(cellValue.substring(0, 5))
      return cellValue.substring(0, 5)
    },
    // 状态格式化
    statusFormat (row, column, cellValue) {
      console.log(cellValue)

      switch (cellValue) {
        case 2:
          return '进行中'
        case 3:
          return '已结束'
      }
    },
    delFn (row) {
      this.title = '停止发布'
      this.resetPasswordMark = true
      this.ids = row.id
    },
    passWordSave () {
      // let formData = new FormData()
      // formData.append('id', this.id)
      stopPublish(this.ids).then(res => {
        this.resetPasswordMark = false
        this.getList(this.searchFrom)
        this.$message({
          message: '停止发布',
          type: 'success'
        })
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 详情
    detailFn (row) {
      this.$router.push({ name: 'details', query: { id: row.id } })
    },
    // 添加
    addClick () {
      this.title = '添加模块'
      this.addBtnShow = true
      this.editBtnShow = false
      this.SQMark = true
    },
    SQsave () {
      this.$refs.SQFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          sModuleAdd(this.SQFrom).then(res => {
            loading.close()
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.SQMark = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 修改
    editFn (row) {
      this.title = '修改时间'
      this.addBtnShow = false
      this.editBtnShow = true
      this.SQMark = true
      this.SQFrom = {
        id: row.id,
        triggerStartDate: row.triggerStartDate.substring(0, 5),
        triggerDuration: row.triggerDuration,
        triggerEndDate: row.triggerEndDate
      }
      // if (this.SQFrom.triggerStartDate) {
      //   let aaT = this.SQFrom.triggerStartDate.substring(0, 2)
      //   this.$set(this.SQFrom, 'triggerStartDate', aaT)
      // }
    },
    editSave () {
      if (this.SQFrom.triggerStartDate) {
        let aaT = this.SQFrom.triggerStartDate.substring(0, 2)
        this.$set(this.SQFrom, 'triggerStartDate', aaT)
      }
      this.$refs.SQFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          updateTriggerTimeInfo(this.SQFrom).then(res => {
            loading.close()
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.SQMark = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    effectiveTime () {
      if (this.SQFrom.triggerDuration > 48) {
        this.$alert('有效时长不大于48小时！', '系统提示')
      }
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      this.loading = true
      cyclicPublishDemandList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
    },
    closeDialog () {
      // this.$refs['SQFrom'].clearValidate()
      this.SQFrom = {
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
// .inpBox1 .el-date-editor{
//   width: 350px!important;
// }
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
.jiage .el-form-item__content {
  position: relative;
  .identiCode1 {
    position: absolute;
    right: 14px;
    color: #409eff;
  }
  .danwei1 {
    position: absolute;
    right: 14px;
    color: white;
    padding: 7px 4px;
  }
}
/deep/.inpBox1 .el-input__inner {
    width: 180px;
}

</style>
